// ChildNode.remove
if(!("remove" in Element.prototype)){
  Element.prototype.remove = function(){
    if(this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/childNode.remove.js
// module id = 843
// module chunks = 2